"use strict";

var _interopRequireDefault = require("/root/www/xmg-cms-fe/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getKittenList = getKittenList;

var _request = _interopRequireDefault(require("@/utils/request"));

function getKittenList(params) {
  return (0, _request.default)({
    url: '/cat/xcx-kitten-list',
    method: 'get',
    params: params
  });
}